import { render, staticRenderFns } from "./old.vue?vue&type=template&id=d85c30da&scoped=true"
import script from "./old.vue?vue&type=script&lang=js"
export * from "./old.vue?vue&type=script&lang=js"
import style0 from "./old.vue?vue&type=style&index=0&id=d85c30da&prod&scoped=true&lang=css"
import style1 from "./old.vue?vue&type=style&index=1&id=d85c30da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85c30da",
  null
  
)

export default component.exports